import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { message } from 'antd'
import { checkAuthorization } from '../../../helpers'

export const getAllHost = createAsyncThunk('host',
    async (object, { dispatch, getState }) => {

        const { userToken }= checkAuthorization()
        dispatch(getting())
        var myHeaders = new Headers()
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name, order: ""})
        }
        fetch(domainUrl + "/viewAllHosts", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success){
                    dispatch(hostResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error)
                dispatch(hostClear()) 
            })
    }
)


const HostSlice = createSlice({
    name: 'host',
    initialState: {
        data: [],
        loading: false,
        pagination:{
            pageNo:1,
            pageSize: 20,
            totalRecords:0,
        },
        filters: {
            name: ''
        },
    },
    reducers: {
        getting: state => {
            state.loading = true
        },
        hostResponse: (state, action) => {
            state.data = action.payload
            state.loading = false
        },
        hostClear: state => {
            state.data = []
            state.loading = false
        },
        changeHostFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
    }
})

export const { getting, hostResponse, hostClear, changeHostFilters, setPages} = HostSlice.actions;
export default HostSlice.reducer;